import { ContractAttachment } from "./ContractAttachment";
import { ContractAuthorization } from "./ContractAuthorization";
import { ContractStep, STEP_ENUM } from "./ContractStep";
import { i18n } from "@/i18n/i18n-setup";
import { NET20_CONTRACT_TYPE } from "@/services/Enums";
import { ReplacementModule } from "./ReplacementModule";

export class Contract {
    public id: string;
    public contractYear: number; 
    public idStep: number;
    public idCustomer: string;
    public idChannel: number; 
    public idSalesman: string;
    public potentialVolume: number; 
    public actualVolume: number; 
    public actualSupplier: number; 
    public actualAgreementSigned: boolean; 
    public actualAgreementExpireDate: Date; 
    public financialRisk: string; 
    public typeOfProposal: string; 
    public signCustomization: string; 
    public signType: string; 
    public signSize: string; 
    public signBrandCustomization: string; 
    public signNameText: string; 
    public signTelephone: string; 
    public signPlannedInstallation: boolean;
    public signInstalled: boolean; 
    public signInstallationDate: Date; 
    public note: string; 
    public contractType: number;
    public currentVersion: []; 
    public contractYearTimespan: number;
    public authorization: ContractAuthorization; 
    public silverTypeOfProposal: boolean = false;
    public signReplacementType: string;
    public signReplacementModules: Array<ReplacementModule>;

    public steps: Array<ContractStep>;
    public attachments: Array<ContractAttachment>;
    
    constructor(
        id?: string,
        contractYear?: number, 
        idStep?: number,
        idCustomer?: string,
        idChannel?: number, 
        idSalesman?: string,
        potentialVolume?: number, 
        actualVolume?: number, 
        actualSupplier?: number, 
        actualAgreementSigned?: boolean, 
        actualAgreementExpireDate?: Date,
        financialRisk?: string, 
        typeOfProposal?: string, 
        signCustomization?: string, 
        signType?: string, 
        signSize?: string, 
        signBrandCustomization?: string, 
        signNameText?: string, 
        signTelephone?: string, 
        signPlannedInstallation?: boolean,
        signInstalled?: boolean, 
        signInstallationDate?: Date, 
        note?: string, 
        contractType?: number,
        currentVersion?: [], 
        contractYearTimespan?: number,
        authorization?: ContractAuthorization, 
        silverTypeOfProposal?: boolean,
        signReplacementType?: string
      ) {
        this.id = id;
        this.contractYear = contractYear; 
        this.idStep = idStep;
        this.idCustomer = idCustomer;
        this.idChannel = idChannel;
        this.idSalesman = idSalesman;
        this.potentialVolume = potentialVolume; 
        this.actualVolume = actualVolume; 
        this.actualSupplier = actualSupplier; 
        this.actualAgreementSigned = actualAgreementSigned; 
        this.actualAgreementExpireDate = actualAgreementExpireDate;
        this.financialRisk = financialRisk; 
        this.typeOfProposal = typeOfProposal; 
        this.signCustomization = signCustomization; 
        this.signType = signType; 
        this.signSize = signSize; 
        this.signBrandCustomization = signBrandCustomization; 
        this.signNameText = signNameText; 
        this.signTelephone = signTelephone; 
        this.signPlannedInstallation = signPlannedInstallation;
        this.signInstalled = signInstalled; 
        this.signInstallationDate = signInstallationDate; 
        this.note = note; 
        this.contractType = contractType;
        this.currentVersion = currentVersion; 
        this.contractYearTimespan = contractYearTimespan;
        this.authorization = authorization; 
        this.silverTypeOfProposal = silverTypeOfProposal;
        this.signReplacementType = signReplacementType;
      }
}

export function GetContractTypeDefinition(contract: Contract): string {
  let definition = "";
  let currentYear = new Date().getFullYear();
  let expirationYear = contract.contractYear + contract.contractYearTimespan;

  if(contract.contractType == NET20_CONTRACT_TYPE.FIRST_CONTRACT)
    definition = i18n.t("NET20.FIRST_CONTRACT") as string;
  else if(contract.contractType == NET20_CONTRACT_TYPE.RENEWAL)
    definition = i18n.t("NET20.RENEWAL_CONTRACT") as string;
  else
    definition = i18n.t("NET20.NEW_CONTRACT") as string;

  if(currentYear >= expirationYear)
    definition = `${definition} ${contract.contractYear} (${i18n.t("NET20.CONTRACT_EXPIRED_IN") as string} ${expirationYear})`;
  else
    definition = `${definition} ${contract.contractYear} (${i18n.t("NET20.CONTRACT_EXPIRES_IN") as string} ${expirationYear})`;

  if(contract.idStep == STEP_ENUM.REFUSED) {
    definition = `${definition} [${i18n.t("NET20.CONTRACT_REFUSED") as string}]`;
  }

  return definition;
}
